import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { LuckyWheelMutationKeys } from '../../../keys'
import {
	UpdateLuckyWheelRequest,
	UpdateLuckyWheelResponse,
} from '../../../type'
import { updateLuckyWheel } from '../../services'

interface UpdateLuckyWheelParams {
	payload: UpdateLuckyWheelRequest
}

export default function useMutationUpdateLuckyWheel(
	props?: UseBaseMutationOptions<
		UpdateLuckyWheelResponse,
		UpdateLuckyWheelParams
	>,
) {
	return useMutation({
		mutationKey: [LuckyWheelMutationKeys.UpdateLuckyWheel],
		mutationFn: (params) => updateLuckyWheel(params.payload),
		...props,
	})
}
